import { Pipe }             from '@angular/core';
import { PipeTransform }    from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateOrderBy'
})
export class OrderTranslatePipe implements PipeTransform
{
  constructor(private translate : TranslateService) {}

  transform(array: Array<any>,  fieldName: string, order: 'asc' | 'desc' = 'asc'): Array<any>
  {
    const ord = order === 'asc' ? -1 : 1;
    array.sort((a: any, b: any) =>
    {
      if (this.translate.instant(a[fieldName]) < this.translate.instant(b[fieldName]))
        return  ord;
      else if (this.translate.instant(a[fieldName]) > this.translate.instant(b[fieldName]))
        return -ord;
      else
        return 0;
    });
    return array;
  }
}
